if($('.player').length){
    var tag = document.createElement('script')

    tag.src = "https://www.youtube.com/iframe_api"
    var firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

    var player = 'player',
        player_wrapper = $('.player'),
        close_player = $('.close-player')

    function onYouTubeIframeAPIReady() {
        player = new YT.Player(player, {
            playerVars: {'rel': 0},
            events: {
                'onReady': function(){
                    console.log('Ready');
                }, 
            }
        })
    }

    close_player.click(function(){
        player.pauseVideo()
        player_wrapper.stop().fadeOut(300)
    })

    $(document).on('click', '.play-video', function(){
        var elem = $(this),
            id = elem.data('id')

        player_wrapper.stop().fadeIn(300)
        player.loadVideoById(id)
    })

}